// Image delivery helper — downsizes Unsplash CDN images to a sane width/quality
// (raw URLs without w= serve multi-MB originals, tanking LCP on mobile).
export const optImg = (url, w = 1200) => {
  if (!url || typeof url !== 'string') return url;
  if (!url.includes('images.unsplash.com')) return url;
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}w=${w}&q=70&auto=format`;
};
